import { render, staticRenderFns } from "./Expert.vue?vue&type=template&id=1b3c94dd&scoped=true"
import script from "./Expert.vue?vue&type=script&lang=js"
export * from "./Expert.vue?vue&type=script&lang=js"
import style0 from "./Expert.vue?vue&type=style&index=0&id=1b3c94dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c94dd",
  null
  
)

export default component.exports